export const config = {
  title: "Arizmendi's Landscaping | Expert Landscaping Services in Tampa, FL",
  meta: {
    description:
      "Arizmendi's Landscaping offers professional landscaping services in Tampa, FL, specializing in transforming outdoor spaces into beautiful and functional environments.",
    keywords: [
      'Landscaping Tampa',
      'Lawn Care',
      'Garden Design',
      'Outdoor Spaces',
      'Arizmendi\'s Landscaping',
      'Landscape Maintenance',
      'Residential Landscaping',
      'Commercial Landscaping',
      'Tampa Landscaping Services',
      'Florida Landscaping',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "Arizmendi's Landscaping",
    canonicalUrl: 'https://arizmendilandscaping.com/',
  },
  sections: {
    header: {
      businessName: "Arizmendi's Landscaping",
    },
    sectionB: {
      heroTitle: "Arizmendi's Landscaping",
      heroSubtitle: 'Transforming Your Outdoor Space Today',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '4076766415',
      phoneLabel: '(407) 676-6415',
      heroBackgroundImage:
        "https://media.istockphoto.com/id/170635446/photo/lawn-mower.jpg?s=612x612&w=0&k=20&c=USw2qaz68osQbejlrltL8fJmzPIvH1vbHd1zDyO_68s=", 
      cardData: [
        {
          title: 'Mission',
          description:
            'At Arizmendi\'s Landscaping, our mission is to transform outdoor spaces into beautiful and functional environments. We believe that every lawn and garden deserves to be a sanctuary for relaxation and enjoyment.',
        },
        {
          title: 'Vision',
          description:
            'Our vision is to be the leading provider of expert landscaping services in Tampa, FL, known for our commitment to quality, creativity, and customer satisfaction.',
        },
        {
          title: 'Why Choose Us',
          description:
            'We stay in constant communication with our customers until the job is done. Our dedication to excellence and personalized service ensures that your outdoor space reflects your vision.',
        },
      ],
      description:
        "Arizmendi's Landscaping offers expert landscaping services for beautiful homes and gardens in Tampa, FL. Our team specializes in creating outdoor spaces that are both aesthetically pleasing and functional.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Discover the comprehensive landscaping services we offer to enhance your outdoor spaces.",
      cards: [
        {
          title: 'Lawn Care',
          description:
            "Maintain a lush and healthy lawn with our professional lawn care services, tailored to meet the specific needs of your yard.",
          imageSrc:
            'https://img1.wsimg.com/isteam/ip/c7caadf3-65ec-4333-90ad-c4edde004c08/IMG_20241113_153752164.jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:370,cg:true',
          imageAlt: 'Lawn Care Service'
        },
        {
          title: 'Garden Design',
          description:
            "Transform your garden into a beautiful and functional space with our innovative garden design services.",
          imageSrc:
            'https://img1.wsimg.com/isteam/ip/c7caadf3-65ec-4333-90ad-c4edde004c08/IMG_20240809_115053881.jpg/:/rs=w:370,cg:true,m', 
          imageAlt: 'Garden Design Service',
        },
        {
          title: 'Seasonal Clean-Ups',
          description:
            'Keep your outdoor spaces tidy and well-maintained throughout the year with our seasonal clean-up services.',
          imageSrc:
            'https://img1.wsimg.com/isteam/ip/c7caadf3-65ec-4333-90ad-c4edde004c08/IMG_20241014_125130465.jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:370,cg:true',
          imageAlt: 'Seasonal Clean-Up Service',
        },
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src:
          'https://img1.wsimg.com/isteam/ip/c7caadf3-65ec-4333-90ad-c4edde004c08/IMG_20241113_153743381.jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:370,cg:true',
        alt: "Arizmendi's Landscaping Team",
      },
      aboutText: [
        "At Arizmendi's Landscaping, we are passionate about creating outdoor spaces that enhance the beauty and functionality of your property. Our team of experts is dedicated to delivering high-quality workmanship and exceptional customer service.",
        "With years of experience in the landscaping industry, we have the knowledge and skills to handle projects of any size and complexity. We work closely with our clients to understand their vision and bring it to life.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Arizmendi's Landscaping",
      businessName: "Arizmendi's Landscaping",
      contact: {
        phone: '4076766415',
        phoneLabel: '(407) 676-6415',
        email: 'arizmendigarcia1@gmail.com',
        website: 'https://arizmendilandscaping.com/',
        address: '1514 E Annie St, Tampa, FL 33612',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '1514 E Annie St, Tampa, FL 33612',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3520.123456789012!2d-82.4456789!3d28.1234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2c1234567890!2s1514+E+Annie+St,+Tampa,+FL+33612!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
